import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import MenuPage from './pages/MenuPage';
import LoginPage from './pages/admin/LoginPage';
import DashboardPage from './pages/admin/DashboardPage';
import RestaurantsPage from './pages/admin/RestaurantsPage';
import CategoriesPage from './pages/admin/CategoriesPage';
import ProductsPage from './pages/admin/ProductsPage';
import CampaignsPage from './pages/admin/CampaignsPage';
import BannersPage from './pages/admin/BannersPage';
import VotesPage from './pages/admin/VotesPage';
import AnalyticsPage from './pages/admin/AnalyticsPage';
import SearchAnalyticsPage from './pages/admin/SearchAnalyticsPage';
import MessagesPage from './pages/admin/MessagesPage';
import SettingsPage from './pages/admin/SettingsPage';
import StoriesPage from './pages/admin/StoriesPage';
import ReactionReportPage from './pages/admin/ReactionReportPage';
import ProtectedRoute from './components/admin/ProtectedRoute';
import ZPanelLoginPage from './pages/zpanel/ZPanelLoginPage';
import ZPanelLayout from './pages/zpanel/ZPanelLayout';
import OrganizationsPage from './pages/zpanel/OrganizationsPage';
import OrganizationDetailPage from './pages/zpanel/OrganizationDetailPage';
import SubscriptionPlansPage from './pages/zpanel/SubscriptionPlansPage';
import ZPanelProtectedRoute from './components/zpanel/ZPanelProtectedRoute';
import ZehumaPortalLayout from './pages/ZehumaPortalLayout';
import ZehumaPortalHome from './pages/ZehumaPortalHome';
import ZehumaPortalAbout from './pages/ZehumaPortalAbout';
import ZehumaPortalFeatures from './pages/ZehumaPortalFeatures';
import ZehumaPortalContact from './pages/ZehumaPortalContact';

function App() {
  return (
    <Router>
      <Routes>
        {/* ZPanel - Süper Admin (/:slug'dan önce olmalı) */}
        <Route path="/zpanel/login" element={<ZPanelLoginPage />} />
        <Route path="/zpanel" element={<ZPanelProtectedRoute><ZPanelLayout /></ZPanelProtectedRoute>}>
          <Route index element={<OrganizationsPage />} />
          <Route path="organizations" element={<OrganizationsPage />} />
          <Route path="organizations/:id" element={<OrganizationDetailPage />} />
          <Route path="subscription-plans" element={<SubscriptionPlansPage />} />
        </Route>

        {/* Zehuma QR Menü — ana site (slug rotasından önce) */}
        <Route path="/" element={<ZehumaPortalLayout />}>
          <Route index element={<ZehumaPortalHome />} />
          <Route path="hakkimizda" element={<ZehumaPortalAbout />} />
          <Route path="ozellikler" element={<ZehumaPortalFeatures />} />
          <Route path="iletisim" element={<ZehumaPortalContact />} />
        </Route>

        {/* Menü: /:slug */}
        <Route path="/:slug" element={<MenuPage />} />

        {/* Admin Routes */}
        <Route path="/admin/login" element={<LoginPage />} />
        <Route 
          path="/admin/dashboard" 
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/organizations/:organizationId/dashboard" 
          element={
            <ProtectedRoute>
              <DashboardPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/organizations/:organizationId/restaurants" 
          element={
            <ProtectedRoute>
              <RestaurantsPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/organizations/:organizationId/categories" 
          element={
            <ProtectedRoute>
              <CategoriesPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/organizations/:organizationId/products" 
          element={
            <ProtectedRoute>
              <ProductsPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/organizations/:organizationId/campaigns" 
          element={
            <ProtectedRoute>
              <CampaignsPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/organizations/:organizationId/banners" 
          element={
            <ProtectedRoute>
              <BannersPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/organizations/:organizationId/votes" 
          element={
            <ProtectedRoute>
              <VotesPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/organizations/:organizationId/analytics" 
          element={
            <ProtectedRoute>
              <AnalyticsPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/organizations/:organizationId/search-analytics" 
          element={
            <ProtectedRoute>
              <SearchAnalyticsPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/organizations/:organizationId/messages" 
          element={
            <ProtectedRoute>
              <MessagesPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/organizations/:organizationId/settings" 
          element={
            <ProtectedRoute>
              <SettingsPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/organizations/:organizationId/stories" 
          element={
            <ProtectedRoute>
              <StoriesPage />
            </ProtectedRoute>
          } 
        />
        <Route 
          path="/admin/organizations/:organizationId/reactions" 
          element={
            <ProtectedRoute>
              <ReactionReportPage />
            </ProtectedRoute>
          } 
        />
      </Routes>
    </Router>
  );
}

export default App;

